/* eslint-disable camelcase */
import initProductRelationships from 'pages/product/desktop/productRelationships';
import { interfaceType } from 'features/productRelationships/constants';
import initStickyHeader from 'pages/product/desktop/stickyHeader'; /* eslint-disable-line no-restricted-imports */
import initImage from 'pages/product/desktop/image'; /* eslint-disable-line no-restricted-imports */
import initWishList from 'pages/product/desktop/wishList'; /* eslint-disable-line no-restricted-imports */
import { addToCart, redirectToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { initStickyHeaderPriceObserver } from 'features/stickyHeaderPrice';
import initFreeShippingTooltip from 'pages/quicklook/desktop/freeShippingTooltip';
import { addToWishList, showAddToWishListError } from 'features/wishList/desktop';
import {
	addClassDuringActivity,
	domReady,
	initBlockEnterKeyForDisabledButton,
	setButtonStateDuringActivity
} from 'utilities/dom';
import { supportsSessionStorage, addSessionStorage } from 'utilities/browser';
import { formatCurrency } from 'utilities/localization';
import { Reporter, visibilityObserver } from 'features/dataCapture';
import { visibilityObserver as productVisibilityObserver } from 'features/product';
import {
	utagLinkProductImpressions,
	ProductImpressionsReporter,
	setProductClick,
	setIndividualProductClick,
	getPathName,
	utagLinkGeneric,
	utagLinkPLA,
	utagLinkStoreAvailability,
	trackSortMoreYouMayLike
} from 'features/tealium';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';
import { trackDyRecommendedItemClickEvent } from 'features/tealium/dynamicYield/recommendedItemsTracking';
import {
	utagLinkProductImpressions as utagLinkGa4ProductImpressions,
	ProductImpressionsReporter as ProductImpressionsGa4Reporter,
	utagLinkSelectItem
} from 'features/tealium/ga4/ecommerce';
import { lpSelect } from 'ui/select';
import { dataCaptureTimeout } from 'ui/config';
import { prefetchWebpackAssetSet } from 'features/webpack';
import { recentlyViewedGAEvents } from 'features/recently-viewed';
import { renderPayPalMessage, getPayPalLaterPaymentPlan } from 'features/paypal';
import AppProductPriceLegalNotice from 'apps/productPriceLegalNotice/desktop';
import { openMessenger } from 'features/genesysCloud';
import { setGenericEvent } from 'features/tealium/ga4/custom';
// extending coupon modal to SFP without changing source code location (currently in sort)
// eslint-disable-next-line no-restricted-imports
import initCouponModal from 'pages/sort/desktop/couponModal';
import { initBreadcrumbTracking } from 'features/breadcrumbs';
import { setCookie, deleteCookie } from 'utilities/browser';
import { isConsentGranted, cookieCategory } from 'features/cookieConsent';

const trackPLAEvents = utagLinkPLA();
const trackStoreAvailability = utagLinkStoreAvailability();
const addClickListenerToPLATrack = (domElement, eventAction) => (domElement
	? domElement.addEventListener('click', () => trackPLAEvents({
		eventAction,
		eventLabel: window.shortSku
	}))
	: null);

const {
	product_impression_sku,
	product_impression_name,
	product_impression_price,
	product_impression_category,
	sku_input_type,
	showPaypalLaterWidget,
	productPrice,
	isSfp,
	product_new_item_date
} = window.lp._ProductListingAd;
const { couponCode, isCouponCodeValid, isColorPlusProduct } = window.lp.pageData;

const downrodOptions = document.getElementById('downrodOptions');
const multiProdOptions = document.querySelector('.multiProdSizeOptions');
const { product_category: productCategory = [] } = window.utag_data;
const [ primaryCategory ] = productCategory;
const checkStoreAvailabilityLink = document.querySelector('.qlStoreLocation__csaLink');
// add to cart functions
let addToCartRecordId;
function addToCartReduceQtyOnSort (quickLookSku, quickLookQty) {

	const sortPageProdEl = window.parent.$(`#sortResultContainer${quickLookSku}`);
	const qtyBefore = parseFloat($('#availInventory').html());
	const qtyNew = qtyBefore - quickLookQty;
	const qtyThreshholdToShow = $('#hdnMaxInventory').val();
	let isFloorLamp = false;

	// ugly if statement to find out if sortPageProdEl is a floor lamp img (taller container)
	if (parseInt(sortPageProdEl.find('.sortResultProdImg').attr('height'), 10) === 336) {

		isFloorLamp = true;

	}

	// Update Quantity Left
	if (qtyBefore <= qtyThreshholdToShow && qtyNew > 0) {

		const sortPageProdElQtyAvail = sortPageProdEl.find('.sortCallout5, .sortCallout6');
		sortPageProdElQtyAvail.html(`${qtyNew} Left`);

	} else if (qtyBefore > qtyThreshholdToShow && qtyNew <= qtyThreshholdToShow && qtyNew > 0) {

		// Append Quantity Left
		const $qtyLeftCallout = $(`<div>${qtyNew} Left</div>`);
		// Quantity Left with Daily Sale Badge
		if (sortPageProdEl.find('.sortCallout4').length > 0) {

			$qtyLeftCallout.addClass('sortCallout5');

		} else {

			// Quantity Left (alone)
			$qtyLeftCallout.addClass('sortCallout6');

		}
		// Offset class for taller floor lamp container
		if (isFloorLamp) {

			$qtyLeftCallout.addClass('floorLamp');

		}
		sortPageProdEl.prepend($qtyLeftCallout);

	} else if (qtyNew === 0) {

		// Append Sold Out
		const $staleCallouts = sortPageProdEl.find('.sortCallout1, .sortCallout4, .sortCallout5, .sortCallout6');
		const hasFloorLampClass = $staleCallouts.hasClass('floorLamp');

		if ($staleCallouts.length > 0) {

			$staleCallouts.remove();

		}

		const $soldOutCallout = $('<div class="sortCallout2">Sold<br />Out</div>');

		if (hasFloorLampClass) {

			$soldOutCallout.addClass('floorLamp');

		}

		sortPageProdEl.find('.sortResultImgContainer').prepend($soldOutCallout);
		sortPageProdEl.find('.sortCallout6').hide();

	}

}

function checkInventory (quickLookQty) {

	if (quickLookQty > window.inventory && window.checkQuantity) {

		$('#pdClearanceInventoryNotification').remove();
		$('.addToCartContainer').prepend(
			`<div id="pdClearanceInventoryNotification"><strong>We're Sorry</strong><br /><br />Only ${
				window.inventory
			} of this item ${
				parseInt(window.inventory, 10) === 1 ? 'is' : 'are'
			} still available. The quantity you entered has been reduced.<br /><br />
			<button type="button" id="pdClearanceInventoryNotificationClose" class="anchorLink">close</button></div>`
		);
		$('#QtyNormal, #QtyMultiProd').val(window.inventory);
		$('#pdClearanceInventoryNotificationClose').on('click', () => {

			$('#pdClearanceInventoryNotification').remove();

		});
		return false;

	}

	return true;

}

const observeAndTrackElements = (skuViews) => {

	if (skuViews.length === 0) {

		return;

	}

	const { reporter } = window.lp.dataCapture;
	const observer = visibilityObserver((element) => {

		const data = Reporter.getSkuViewData(element);
		reporter.track(data);

	});
	skuViews.forEach((element) => observer.observe(element));

};

const immediateTrackMainProduct = (skuViews) => {

	if (skuViews.length === 0) {

		return;

	}

	const { reporter } = window.lp.dataCapture;

	skuViews.forEach((element) => {

		const data = Reporter.getSkuViewData(element);
		reporter.track(data, { immediate: true });

	});

};

function initDataCapture () {

	if (!window.lp.globals.enableDataCapture) {

		return;

	}

	if (window.lp.globals.canShowCertona) {

		document.addEventListener('recommendedItems:similar2:loaded', () => {

			observeAndTrackElements(document.querySelectorAll('#certonaItems img[data-sku]'));

		});

	}

	immediateTrackMainProduct(document.querySelectorAll('#qlProdImg img[data-sku]'));

}

function waitForDataCaptureAndRedirectToCart () {

	const promoCode = document.getElementById('promoCouponCodeCheckbox');
	const queryStringParams = promoCode && promoCode.checked ? `a=${promoCode.value}` : '';

	if (!window.lp.globals.enableDataCapture) {

		redirectToCart(queryStringParams);
		return;

	}
	const { reporter } = window.lp.dataCapture;
	const pageImg = document.getElementById('staticImage') || document.querySelector('#pdImgContainer');
	const skuViewRecord = reporter.getRecordByElement(pageImg);
	const skuViewRequest = skuViewRecord ? skuViewRecord.promise : reporter.track(Reporter.getSkuViewData(pageImg));

	const atcRecord = reporter.getRecordById(addToCartRecordId);
	const atcRequest = atcRecord.promise;

	const timeout = window.setTimeout(() => redirectToCart(queryStringParams), dataCaptureTimeout);
	Promise.all([ skuViewRequest, atcRequest ]).finally(() => {

		window.clearTimeout(timeout);
		redirectToCart(queryStringParams);

	});

}

function quickLookAddToCart (quickLookSku, quickLookQty, quickLookTestCompositionId, quickLookPrice, skuInputType) {

	const $el = $('#pdAddToCart, #AddToCart_Multiproduct, #pdAddToCartSticky, #pdAddToCartStickyFaceplate').addClass(
		'noPointerEvents disabled loading'
	);

	const { _ProductListingAd } = window.lp;
	const data = [
		{
			Name: _ProductListingAd.product_impression_name,
			Price: quickLookPrice,
			Category: _ProductListingAd.product_impression_category,
			Brand: _ProductListingAd.product_brand,
			Style: _ProductListingAd.product_style,
			ShortSku: quickLookSku,
			Quantity: quickLookQty,
			TestCompositionId: quickLookTestCompositionId,
			SkuInputType: skuInputType
		}
	];
	const listType =		document.getElementById('qlBkg') && document.getElementById('qlBkg').getAttribute('data-list-type');

	const { reporter } = window.lp.dataCapture;
	const addToCartButton = $el.length
		? $el[0]
		: document.querySelector(
			'#pdAddToCart, #AddToCart_Multiproduct, #pdAddToCartSticky, #pdAddToCartStickyFaceplate'
		  );
	const $customDownrodRadio = $('input[name=downrodOption]');
	if ($customDownrodRadio.length) {

		const downrodSku = $('input[name=downrodOption]:checked').val();
		const skuInputType = $('input[name=downrodOption]:checked').data('sku-input-type');
		if (Number(downrodSku) !== 0) {

			data.push({
				ShortSku: downrodSku,
				Quantity: quickLookQty,
				TestCompositionId: quickLookTestCompositionId,
				SkuInputType: skuInputType
			});

		}

	}
	if (window.lp.globals.enableDataCapture) {

		reporter.trackAddToCart(data, addToCartButton);
		addToCartRecordId = reporter.getLastRecordId();

	}

	addToCart({
		arrData: data,
		successCallback () {

			const cookieName = `ATC-AddedItems-ShortSKUs`;
			if (isConsentGranted(cookieCategory.Functional)) {
				setCookie(cookieName, quickLookSku);
			} else {
				deleteCookie(cookieName);
			}

			if ($('#availInventory').html()) {

				addToCartReduceQtyOnSort(quickLookSku, quickLookQty);

			}
			waitForDataCaptureAndRedirectToCart();

		},
		errorCallback (errors, xhr, response) {

			const fromModal = false;
			$el.removeClass('noPointerEvents disabled loading');
			showAddToCartFailureModal({
				cartStatus: errors,
				response,
				fromModal
			});

		},
		includeCartOverview: false,
		rememberLastAddedItem: true,
		sortParams: {
			SortSku: quickLookSku,
			ListType: listType,
			SortPath: getPathName()
		}
	});

	return false;

}

function CheckQty (txtQty) {

	if (!txtQty.value || parseInt(txtQty.value, 10) <= 0) {

		txtQty.value = '1';

	}

}

function onFocusNumericOnly (oTextbox) {

	let sReturnValue;
	sReturnValue = '';
	let i;
	for (i = 0; i < oTextbox.value.length; i++) {

		if (oTextbox.value.charCodeAt(i) >= 48 && oTextbox.value.charCodeAt(i) <= 57) {

			sReturnValue += oTextbox.value.charAt(i);

		}

	}
	oTextbox.value = sReturnValue;
	return true;

}

function addItemToWishList (shortSku, qty, redirectToWishlist) {

	const data = [
		{
			ShortSku: shortSku,
			Quantity: qty || 1
		}
	];
	const request = addToWishList(
		data,
		() => {

			if (redirectToWishlist) {

				window.top.location.href = '/wish-list';
				return;

			}

			window.parent.$('#lpModalClose').trigger('click');

			const $sortItemImgContainer = window.parent.$(`#sortResultContainer${shortSku} .sortResultImgContainer`);

			$sortItemImgContainer.prepend(
				`<div id="sortPortfolioConfirmation${shortSku}" class="sortPortfolioConfirmation"></div>`
			);
			const $sortItemWishListConfirmation = window.parent.$(`#sortPortfolioConfirmation${shortSku}`);
			$sortItemWishListConfirmation.html('<h1>Compare two or more items in your Wish List</h1>');

			// fade in
			$sortItemWishListConfirmation.fadeTo(500, 0.9, () => {

				// fade out
				$sortItemWishListConfirmation.delay(1500).fadeOut(500, () => {

					// remove from dom
					$sortItemWishListConfirmation.remove();

				});

			});

			window.parent.lp.utils.getAssetCounts();

		},
		(maxItemCountReached) => {

			showAddToWishListError(maxItemCountReached, true);

		}
	);

	const addToWishListElement = document.querySelector('.addToWishList');
	addClassDuringActivity(addToWishListElement, 'disabled loading noPointerEvents', request);

}

function captureSkuAndPosition (sortResultContainers) {

	sortResultContainers.forEach((sortResultContainer) => {

		sortResultContainer.addEventListener('click', (e) => {

			const imageElement = e.currentTarget.querySelector('.sortResultImgContainer > img');
			const sku = imageElement.getAttribute('data-sku');
			const position = imageElement.getAttribute('data-position');
			const listType = document?.getElementById('qlCertonaContainer')?.getAttribute('data-list-type');
			const sessionStorageObject = {};

			if (supportsSessionStorage() && sku && position) {

				// Save data to sessionStorage
				sessionStorageObject.sortSku = sku;
				sessionStorageObject.sortPosition = position;

			}

			if (supportsSessionStorage() && listType) {

				sessionStorageObject.listType = listType;

			}

			addSessionStorage(sessionStorageObject);

		});

	});

}

function initStoreAvailabilityModal () {

	const storeAvailabilityLink = document.querySelector('.qlStoreLocation__csaLink');
	if (storeAvailabilityLink) {

		storeAvailabilityLink.addEventListener('click', (e) => {

			e.preventDefault();
			const geoZip = e.currentTarget.dataset.geozip;

			import('pages/product/desktop/checkStoreAvailability/initCheckStoreAvailability').then((module) => {

				const initCheckStoreAvailability = module.default;
				initCheckStoreAvailability({ shortSku: window.shortSku, zipCode: geoZip || '' });

			});

		});

	}

}

function initStoreInfoModal () {

	const qlStoreLocationLink = document.querySelector('.qlStoreLocation__link');

	if (qlStoreLocationLink) {

		const { shortSku } = window.lp._ProductListingAd;
		const storeName = qlStoreLocationLink.getAttribute('data-store-name');
		const storeNumber = qlStoreLocationLink.getAttribute('data-store-number');
		const storeDirectionLink = document.querySelector('.qlStoreLocationInfo__link');
		const eventAction = (prefix) => `${prefix}${storeName} #${storeNumber}`;

		trackPLAEvents({
			eventAction: eventAction('Load-Available-At-'),
			eventLabel: shortSku,
			nonInteraction: 1
		});

		qlStoreLocationLink.addEventListener('click', () => {

			$('body').lpModal({
				onInit: true,
				width: 610,
				height: 230,
				lpModalClass: 'lpModal--alt1',
				content: $('.qlStoreLocationInfo')
			});

			const { shortSku } = window.lp._ProductListingAd;

			trackPLAEvents({
				eventAction: eventAction('Click-StoreAddress&Hours-'),
				eventLabel: shortSku
			});

		});

		addClickListenerToPLATrack(storeDirectionLink, eventAction('Click-Available-At-StoreDetails-'));

	}

}

function captureSkuAndListType (link, list_type) {

	const sessionStorageObject = {};
	const sku = window.utag_data.product_sku;
	const listType = list_type || window.utag_data.list_type;
	const sortPath = window.parent.location.href;

	// Save data to sessionStorage
	function setListTypeInSessionStorage () {

		sessionStorageObject.listType = listType || '';
		addSessionStorage(sessionStorageObject);

	}

	if (supportsSessionStorage()) {

		setListTypeInSessionStorage();
		link.addEventListener('click', () => {

			sessionStorageObject.sortSku = sku || '';
			sessionStorageObject.sortPath = sortPath || '';
			setListTypeInSessionStorage();

		});

	}

}

function addEventsOnDynamicElements () {

	// add to cart
	$('#pdAddToCart, #AddToCart_Multiproduct, #pdAddToCartSticky, #pdAddToCartStickyFaceplate').on(
		'click',
		function () {

			// if add to cart button is disabled
			if ($(this).is('.disabled')) {

				return false;

			}

			// if add to cart button is not disabled
			const quickLookSku = $('.qlTitleSku').html();
			const quickLookQty = parseFloat($('#QtyNormal, #QtyMultiProd').val());
			const multiProdInput = document.querySelector('input[name=MultiproductRadio]:checked');
			const quickLookPrice = multiProdInput
				? multiProdInput.getAttribute('data-price')
				: window.lp._ProductListingAd.product_impression_price;
			const quickLookTestCompId = (utag_data.testcomposition_id && utag_data.testcomposition_id[0]) || null;
			const skuInputType = multiProdInput
				? multiProdInput.getAttribute('data-sku-input-type')
				: window.lp._ProductListingAd.sku_input_type[0];

			if (window.top.DY) {

				try {

					trackAddToCartDy(window.shortSku, parseFloat((quickLookPrice * quickLookQty).toFixed(2)), quickLookQty);

				} catch (e) {

					console.warn('DY API is not available', e);

				}

			}

			if (checkInventory(quickLookQty)) {

				quickLookAddToCart(quickLookSku, quickLookQty, quickLookTestCompId, quickLookPrice, skuInputType);

			}

			return false;

		}
	);

	// qty checks
	$('#QtyNormal, #QtyMultiProd').on('blur', function () {

		onFocusNumericOnly(this);
		CheckQty(this);

	});

	// on keypress, check for add to cart
	$('#QtyNormal, #QtyMultiProd')
		// Input filter for Quantity field
		.inputFilter({ type: 'integer' })
		// add product to cart with Enter
		.on('keypress', (e) => {

			if (e.which === 13) {

				$('#pdAddToCart, #AddToCart_Multiproduct, #pdAddToCartSticky, #pdAddToCartStickyFaceplate').click();
				e.preventDefault();

			}

		});

	addClickListenerToPLATrack(document.getElementById('qlViewDetails'), 'Click-View Details');
	addClickListenerToPLATrack(document.querySelector('.qlTitleWrapper h1 > a'), 'Click-Product Title');

	$('.qlTitleWrapper h1 > a, #divReview, #qlViewDetails').on(
		'click',
		() => {

			const multiProdInput = document.querySelector('input[name=MultiproductRadio]:checked');

			utagLinkSelectItem({
				sku: $('.qlTitleSku').html(),
				name: $('.qlTitleWrapper h1 > a').html(),
				price: multiProdInput ? multiProdInput.getAttribute('data-price') : window.lp._ProductListingAd.product_impression_price,
				skuInputType: multiProdInput ? multiProdInput.getAttribute('data-sku-input-type') : window.lp._ProductListingAd.sku_input_type[0],
				primaryCategory: multiProdInput ? multiProdInput.getAttribute('data-primary-category') : window.lp._ProductListingAd.product_impression_category[0]
			});

		}
	);

}

function renderPayPalLaterWidget (amount) {

	if (showPaypalLaterWidget) {

		let paymentPlan;
		const eventCategory = isSfp ? 'SFP' : 'PLA';

		renderPayPalMessage({
			amount,
			selector: '#paypalLaterWidget',
			onRender: (e) => {

				paymentPlan = getPayPalLaterPaymentPlan(e.meta?.creditProductIdentifier);

			},
			onClick: () => {

				utagLinkPLA(eventCategory)({
					eventAction: 'Click-PayPal-Later-Popup',
					eventLabel: `${paymentPlan} for ${formatCurrency(amount, false, false)}`
				});

			},
			onApply: () => {

				utagLinkPLA(eventCategory)({
					eventAction: 'Click-PayPal-Later-Apply',
					eventLabel: `${paymentPlan} for ${formatCurrency(amount, false, false)}`
				});

			}
		});

	}

}

function initAvailableOptionsDropdown () {

	lpSelect(multiProdOptions);

	multiProdOptions.querySelectorAll('.multiProdSizeOptions__option-text').forEach((elem) => {

		elem.addEventListener('click', () => {

			const multiProdQtyElem = document.getElementById('QtyMultiProd');

			// Reset quantity to 1
			if (multiProdQtyElem) {

				multiProdQtyElem.value = 1;

			}

		});

	});

	multiProdOptions.querySelectorAll('input[type="radio"]').forEach((elem) => elem.addEventListener('change', (e) => {

		const removeLineBreaks = (str) => str.replace(/(\r\n|\n|\r)/gm, '');
		const closestOption = elem.closest('.multiProdSizeOptions__option');
		const newOptionText = removeLineBreaks(
			closestOption.querySelector('.multiProdSizeOptions__option-text .listNameText').innerText
		);
		const sku = e.target.value.toUpperCase();
		const { price, firstShipDays } = elem.dataset;

		// Find the group heading text for selected option
		let closestGroupHeader = closestOption.previousElementSibling;
		while (closestGroupHeader && !closestGroupHeader.classList.contains('multiProdSizeOptions__group-header')) {

			closestGroupHeader = closestGroupHeader.previousElementSibling;

		}
		const newGroupText = closestGroupHeader
			? ` ${removeLineBreaks(
				closestGroupHeader.querySelector('.multiProdSizeOptions__group-header-text').innerText
				  )}`
			: '';

		// Change title and price
		document.querySelector('.qlItemInfo').innerHTML = document.getElementById(
			`multiProductTemplate_${sku}`
		).innerHTML;

		// Change sticky subtitle
		const stickySubTitle = document.querySelector('.pdProdFullTitleSticky__subtitle');
		if (stickySubTitle) {

			stickySubTitle.innerText = `${newOptionText.trim()}${newGroupText.trim()}`;

		}

		// update sku/name vars used on click event listeners
		window.shortSku = sku;
		window.lp._ProductListingAd.shortSku = sku;
		window.lp._ProductListingAd.product_impression_sku = [ sku ];
		window.lp._ProductListingAd.product_impression_name = [
			document.querySelector('#h1ProductName a').innerText
		];

		addEventsOnDynamicElements();

		// must go here, after the code above that replaces inner html
		const inStockLabel = document.getElementById('qlInStockLabel');
		const pleaseCallMessage = document.getElementById('pnlPleaseCallCustomerService');
		const productActionPanel = document.querySelector('.pdAssetActions');

		// toggle add to cart/qty and customer service message based on firstShipDays value
		if (Number(firstShipDays) >= 57) {

			if (productActionPanel) {

				productActionPanel.classList.add('hidden');

			}

			if (pleaseCallMessage) {

				pleaseCallMessage.classList.remove('hidden');

			}

		} else {

			if (productActionPanel) {

				productActionPanel.classList.remove('hidden');

			}

			if (pleaseCallMessage) {

				pleaseCallMessage.classList.add('hidden');

			}

		}

		if (inStockLabel) {

			// toggle in stock label based on firstShipDays value
			if (Number(firstShipDays) <= window.lp._ProductListingAd.inStockLabelDays) {

				inStockLabel.classList.remove('hidden');

			} else {

				inStockLabel.classList.add('hidden');

			}

		}

		if (!isSfp) {

			renderPayPalLaterWidget(price);

		}

	}));

	observeAndTrackElements(
		document.querySelectorAll('[data-capture-section="AvailableOptions"] label[data-sku]:not([data-sku="0"])')
	);

}

function trackMultiOptionsEvents () {

	const multiOption = document.querySelectorAll('.lpSelectWrapper .multiProdSizeOptions >li');
	if (multiOption && multiOption.length > 1) {

		const urlParams = new URLSearchParams(window.location.search);
		const eventCategory = urlParams.get('sfp') ? 'PLA' : 'SFP';

		utagLinkPLA(eventCategory)({
			eventAction: 'Load-Multi-Option',
			eventLabel: window.shortSku,
			nonInteraction: 1
		});
		const listName = document.querySelectorAll(
			'.lpSelectWrapper .multiProdSizeOptions >li .multiProdSizeOptions__option-text'
		);
		listName.forEach((ele) => {

			ele.addEventListener('click', (el) => {

				const eventLable = el.currentTarget.querySelector('.listNameText')
					? el.currentTarget.querySelector('.listNameText').innerText.trim()
					: '';
				utagLinkPLA(eventCategory)({
					eventAction: 'Select-Multi-Option',
					eventLabel: `${window.shortSku}-${eventLable}`
				});

			});

		});

	}

}

function callNotifyMeApi (userEmail, shortSku) {

	return fetch('/api/emails/products/itememailnotification/', {
		method: 'post',
		headers: {
			Accept: 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({ ShortSku: shortSku, EmailAddress: userEmail })
	});

}

function initNotifyMe () {

	const notifyMeForm = document.getElementById('notify-me-form');
	const submitButton = document.getElementById('notifyMeSubmitBtn');
	if (notifyMeForm) {

		const sfpProductLink = document.getElementById('staticImage');
		const sku = sfpProductLink ? sfpProductLink.dataset.sku : '';
		const shortSku = sku || window.shortSku || getQueryStringValue('sfp');

		trackPLAEvents({
			eventAction: 'Load-Notify-Me',
			eventLabel: shortSku,
			nonInteraction: 1
		});
		setGenericEvent({
			event_name: 'sfp_notifyme_load',
			sfp_item_id: shortSku,
			sfp_prime_cat: primaryCategory
		});
		initBlockEnterKeyForDisabledButton(submitButton);
		window.initFormValidation(true, '#notify-me-form', {
			errorElement: 'span',
			success: 'valid',
			invalidHandler: function invalidHandler (form, validator) {

				const errors = validator.numberOfInvalids();

				if (errors) {

					validator.errorList[0].element.focus();

				}

			}
		});

		notifyMeForm.addEventListener('submit', (e) => {

			e.preventDefault();
			const genericErrorMessage = 'Sorry! We ran into a problem. Please try again later.';
			if ($(notifyMeForm).valid()) {

				const emailField = document.getElementById('notifyMeEmail');
				const userEmail = emailField ? emailField.value : '';
				const errorMessage = document.getElementById('notifyMeError');
				const successMessage = document.getElementById('notifyMeSuccess');
				successMessage.style.display = 'none';
				errorMessage.style.display = 'none';

				const request = callNotifyMeApi(userEmail, shortSku)
					.then((response) => {

						if (response.status === 200) {

							trackPLAEvents({
								eventAction: 'Submit-Notify-Me',
								eventLabel: shortSku
							});
							setGenericEvent({
								event_name: 'sfp_notifyme_submit',
								sfp_item_id: shortSku,
								sfp_prime_cat: primaryCategory
							});
							successMessage.style.display = 'flex';
							notifyMeForm.style.display = 'none';

						} else {

							errorMessage.innerText = response.ErrorMessage || genericErrorMessage;

							successMessage.style.display = 'none';
							errorMessage.style.display = 'block';

						}

					})
					.catch((error) => {

						errorMessage.innerText = genericErrorMessage;
						successMessage.style.display = 'none';
						errorMessage.style.display = 'block';

					});

				setButtonStateDuringActivity(submitButton, request);

			}

		});

	}

}

function trackProductAvailability () {

	const {
		callForAvailability, notAvailable, shortSku, isDiscontinued
	} = window.lp._ProductListingAd;

	// track product availability
	if (callForAvailability) {

		utagLinkPLA()({
			eventAction: 'Product Unavailable - Call For Availability',
			eventLabel: shortSku,
			nonInteraction: 1
		});

	}

	if (notAvailable) {

		const pdSoldOut = document.getElementById('soldOutLabel');

		if (pdSoldOut && !pdSoldOut.classList.contains('hidden')) {

			utagLinkPLA()({
				eventAction: 'Product Unavailable - Sold Out',
				eventLabel: shortSku,
				nonInteraction: 1
			});

		} else if (isDiscontinued) {

			utagLinkPLA()({
				eventAction: 'Product Unavailable - Discontinued',
				eventLabel: shortSku,
				nonInteraction: 1
			});

		} else {

			utagLinkPLA()({
				eventAction: 'Product Unavailable - Not Available on PLA',
				eventLabel: shortSku
			});

		}

	}

}

function initStickyHeaderPrice () {

	const stickyHeader = document.getElementById('stickyHeader');
	if (!stickyHeader) {

		return;

	}

	const stickyPrice = stickyHeader.querySelector('.stickyPriceContainer__priceTop');
	const stickyAdditionalPrice = stickyHeader.querySelector('.priceAdditional');
	const productPricePanel = document.querySelector('.qlItemInfo');

	initStickyHeaderPriceObserver({
		stickyPrice,
		stickyAdditionalPrice,
		productPricePanel,
		// no stickyPriceType and productPriceTypeSelector params because
		// priceType and price are combined in one container in productPriceSelector callback
		productPriceSelector: () => {

			// this includes priceType and price
			const selectedOption = document.querySelector('.multiProdSizeOptions__option.selected');
			return selectedOption ? selectedOption.querySelector('.stickyPriceContainer__priceTop') : null;

		},
		additionalPriceSelector: () => {

			const selectedOption = document.querySelector('.multiProdSizeOptions__option.selected');
			return selectedOption ? selectedOption.querySelector('.priceAdditional') : null;

		}
	});

}

function initProductPriceLegalNotice () {

	const container = document.querySelector('.strikedPdPriceTooltipWrapper');
	if (container) {

		const tooltipTrigger = container.querySelector('.AppProductPriceLegalNotice__trigger');
		AppProductPriceLegalNotice(container, tooltipTrigger);

	}

}

function initOpenboxEplainerTooltip () {

	const container = document.querySelector('#openBoxPlaLinkWrapper');
	if (container) {

		const tooltipTrigger = container.querySelector('.openBoxPlaExplainer__trigger');
		AppProductPriceLegalNotice(
			container,
			tooltipTrigger,
			{ evtType: 'hover' },
			'.openboxPlaExplainer',
			'.openboxPlaExplainer__content'
		);

	}

}

function initChatEvent () {

	const chatButtons = document.querySelectorAll('#qlProdContent .chatWrapperWithIcon button');

	if (chatButtons.length) {

		chatButtons.forEach((chatButton) => {

			chatButton.addEventListener('click', () => {

				openMessenger();
				setGenericEvent({
					event_name: 'chat_click',
					chat_button_type: 'static',
					chat_button_text: 'Chat'
				});

			});

		});

	}

}

domReady(() => {

	initChatEvent();
	// bind GA events when Recently Viewed Widget is ready
	document.addEventListener('recommendedItems:loaded', () => recentlyViewedGAEvents(trackPLAEvents));

	addClickListenerToPLATrack(document.getElementById('staticImage'), 'Click-Product Image');
	document
		.querySelectorAll('.categoryNavList a')
		.forEach((el) => addClickListenerToPLATrack(el, `Click-Related-${el.textContent.trim()}`));

	// wishlist.addToWishlist().init();
	initWishList().init();
	if (document.querySelector('#pdImgContainer')) {

		initImage().init();

	}

	// init sticky header
	initStickyHeader().init();

	// override previous qty's entered, and focus on the qty input
	$('#QtyNormal', '#QtyMultiProd').val('1');
	setTimeout(() => {

		$('#QtyNormal', '#QtyMultiProd').focus();

	}, 500);

	$('.pdOtherOptions .next.disabled, .pdGicleeShadeOptions .next.disabled').unbind('click');

	if ($('.pdScrollableThumb').length) {

		const url = $('.qlViewDetailsBtn').attr('href').split('?')[0];

		$('.pdScrollableThumb').click(function () {

			window.top.location = `${url}?giclee-data-color=${$(this).attr('data-color')}&giclee-data-sku=${$(
				this
			).attr('data-sku')}`;

		});

	}

	if ($('.pdOtherOptionsThumb').length) {

		$('.pdOtherOptionsThumb').attr('target', '_parent');

	}

	addEventsOnDynamicElements();

	// quick look email button
	$('body').on('click', '#qlEmailButton', function () {

		const qlContainer = window.parent.$('#lpModalContent');
		const quickLookiFrame = window.parent.$('#lpModalContent iframe');
		const emailFriendiFrame = window.parent
			.$('<iframe/>')
			.attr('src', this.href)
			.attr('frameborder', '0')
			.attr('width', '820')
			.attr('height', '462')
			.attr('id', 'emailFriendiFrame');
		quickLookiFrame.hide();
		quickLookiFrame.fadeOut();
		qlContainer.append(emailFriendiFrame);
		window.parent.$('#lpModal, #lpModalContent').animate(
			{
				height: '462px',
				width: '820px'
			},
			1500,
			() => {}
		);
		$('#emailFriendiFrame').hide().fadeIn(1500);
		return false;

	});

	// Forcing links to follow in main window, not inside the iframe
	$('.qlViewDetailsBtn, #qlReadMore, #bdQL .prReviewRating a, #artShadeLinks a, a[data-follow]').click(function () {

		if (window.parent.parent) {

			window.parent.parent.location = $(this).attr('href');

		}
		window.parent.location = $(this).attr('href');
		return false;

	});

	$('.backToTopButton, .lpIcon-backtotop').on('click', () => {

		$('html, body').animate({ scrollTop: 0 }, 800);

	});

	const fullPage = document.querySelector('.fullPage');

	if (window.lp.globals.canShowCertona && fullPage) {

		window.lp.certona.getRecommendedItems();

	}

	const { shortSku } = window.lp._ProductListingAd;
	if (checkStoreAvailabilityLink) {

		trackStoreAvailability({
			eventAction: 'LIA-Load-Check-Store',
			eventLabel: shortSku,
			nonInteraction: 1
		});

		checkStoreAvailabilityLink.addEventListener(
			'click',
			() => {

				const { shortSku } = window.lp._ProductListingAd;
				trackStoreAvailability({
					eventAction: 'LIA-Click-Check-Store',
					eventLabel: shortSku
				});

			},
			{ once: true }
		);

	}
	if (downrodOptions) {

		lpSelect(downrodOptions);

		const mainSelector = downrodOptions.parentNode.querySelector('.mainSelector');

		mainSelector.addEventListener('click', (e) => {

			const sku = $('.qlTitleSku').html();

			utagLinkGeneric({
				eventCategory: 'SFP-Full',
				eventAction: 'Click-DownrodOptionsList',
				eventLabel: sku
			});

		});

		downrodOptions.querySelectorAll('input[type="radio"]').forEach((elem) => {

			elem.addEventListener('change', (e) => {

				const li = e.target.closest('li.selected');

				const downrodOptionsTxt = li ? li.querySelector('.listName').innerText : '';

				utagLinkGeneric({
					eventCategory: 'SFP-Full',
					eventAction: 'Click-DownrodLength',
					eventLabel: downrodOptionsTxt
				});

			});

		});

		observeAndTrackElements(
			document.querySelectorAll('[data-capture-section="Downrods"] label[data-sku]:not([data-sku="0"])')
		);

	}

	initProductPriceLegalNotice();
	initOpenboxEplainerTooltip();

	// Track Breadcrumb
	initBreadcrumbTracking();

	const trackPriceEvent = () => {

		const lblPrice = document.getElementById('lblPrice');
		if (lblPrice) {

			const priceText = lblPrice.innerText.replace('$', '');
			const clearancePriceType = document.querySelector('.clearancePriceType');
			const salePriceType = document.querySelector('.salePriceType');
			const eventActionPriceType = clearancePriceType ? 'Clearance' : salePriceType ? 'Sale' : 'Main';
			const eventAction = `PLA-Price-${eventActionPriceType}-${priceText}`;
			trackPLAEvents({
				eventAction,
				eventLabel: window.shortSku,
				nonInteraction: 1
			});

		}

	};

	const trackSpecialValueEvent = () => {

		const lblPriceType = document.querySelector('#lblPriceType');
		if (lblPriceType && lblPriceType.innerText.toLowerCase() === 'special value') {

			trackPLAEvents({
				eventAction: 'Load-Special Value Pricing',
				eventLabel: window.shortSku,
				nonInteraction: 1
			});

		}

	};

	if (multiProdOptions) {

		initAvailableOptionsDropdown();

	}

	let dataSkuArr;
	let eventActionText;

	if (window.location.pathname.indexOf('/sfp/') < 0) {

		dataSkuArr = window.location.href.split('sfp=');
		const mainElement = document.querySelector('#qlBkg');
		const isLPValue = mainElement?.getAttribute('data-product-is-lpproduct');
		eventActionText = Number(isLPValue) ? 'IsLPSKUTrue' : 'IsLPSKUFalse';

	} else {

		dataSkuArr = window.location.pathname.split('/sfp/');
		eventActionText =			Array.isArray(window.utag_data.product_islpproduct) && Number(window.utag_data.product_islpproduct[0]) > 0
			? 'IsLPSKUTrue'
			: 'IsLPSKUFalse';

	}

	const dataSku = dataSkuArr[1]?.replace('/', '');

	trackPLAEvents({
		eventAction: eventActionText,
		eventLabel: dataSku,
		nonInteraction: 1
	});

	if (!isSfp) {

		renderPayPalLaterWidget(productPrice);

	}

	initStoreAvailabilityModal();
	initStoreInfoModal();
	initDataCapture();
	initNotifyMe();
	initFreeShippingTooltip();

	// Only in Multi-products PLA/SFP does the price can get dynamically updated
	if (document.querySelectorAll('.multiProdSizeOptions__option').length > 0) {

		initStickyHeaderPrice();

	}

	prefetchWebpackAssetSet('desktop/cart/overview');
	prefetchWebpackAssetSet('desktop/product');

	trackMultiOptionsEvents();
	trackPriceEvent();
	trackSpecialValueEvent();

	initCouponModal(couponCode, isCouponCodeValid);

	// Show the promo code for Color Plus products.
	// This is a workaround because the Model of the partial that renders the promo code doesn't have a Color Plus flag.
	// This flag is available and set on the main view (QuickLook.cshtml) which calls the partial view.
	if (isColorPlusProduct) {

		const promoCouponCode = document.querySelector('.promoCouponCode--colorPlus');
		promoCouponCode?.classList.remove('hidden');

	}

	// initialize product relationships on page load
	// eslint-disable-next-line no-underscore-dangle
	/*
	const { relationshipGroupsData } = lp._ProductListingAd;
	initProductRelationships(interfaceType.desktop, relationshipGroupsData);
	*/

});

window.addEventListener('load', () => {

	const container = document.querySelector('#qlCertonaContainer, #sortResultProducts');
	// ?sfp=sku
	const isSfpSort = container && container.id === 'sortResultProducts';
	trackProductAvailability();

	let listType = document.getElementById('qlBkg') && document.getElementById('qlBkg').getAttribute('data-list-type');

	utagLinkProductImpressions({
		product_impression_sku,
		product_impression_list: [ getPathName() ],
		product_impression_name,
		product_impression_price,
		product_impression_category,
		list_type: listType,
		gua_non_interaction: true,
		product_grouping: window.utag_data.product_grouping,
		sku_input_type
	});

	utagLinkGa4ProductImpressions({
		product_impression_sku,
		product_impression_name,
		product_impression_price,
		product_impression_category,
		product_grouping: window.utag_data.product_grouping,
		primaryCategory: product_impression_category,
		sku_input_type,
		product_new_item_date
	});

	// Capture product impressions of sort items on SFP full page, not SFP on Sort page itself)
	if (!isSfpSort) {

		// init product impressions capturing for utag

		const reporter = new ProductImpressionsReporter({
			list_type: listType,
			product_grouping: window.utag_data.product_grouping
		});

		const reporterGa4 = new ProductImpressionsGa4Reporter({
			product_grouping: window.utag_data.product_grouping
		});
		const observer = productVisibilityObserver((element) => {

			const modifiedElment = {
				...element,
				dataset: { ...element.dataset, primaryCategory: product_impression_category[0] }
			};
			const record = reporter.getProductImpressionDataFromElement(modifiedElment);
			reporter.track(record);

			const recordGa4 = reporterGa4.getProductImpressionDataFromElement(modifiedElment);
			reporterGa4.track(recordGa4);

		});

		const elements = document.querySelectorAll('.sortResultProdImg[data-sku]');
		elements.forEach((element) => {

			observer.observe(element);

		});

	}

	// setup product click for quicklook PLA panel
	const qlContainer = document.getElementById('qlBkg');

	if (qlContainer) {

		const qlProductLinks = [];
		const qlProductImg = qlContainer.querySelector('#qlProdImg > a');
		const qlProductTitle = qlContainer.querySelector('#qlProdContent .qlTitleWrapper a');
		const qlViewDetail = qlContainer.querySelector('.qlViewDetailsBtn');
		const qlShippingTime = qlContainer.querySelector('.stockCheck');
		const qlOpenBoxPlaLink = qlContainer.querySelector('#openBoxPlaLink');
		const turntoTeaser = document.querySelectorAll('.pdSummaryTeaser--link');

		if (qlProductImg) {

			qlProductLinks.push(qlProductImg);

		}
		if (qlProductTitle) {

			qlProductLinks.push(qlProductTitle);

		}
		if (qlViewDetail) {

			qlProductLinks.push(qlViewDetail);

		}
		if (qlShippingTime) {

			trackPLAEvents({
				eventAction: `Ship Time - ${qlShippingTime.innerText}`,
				eventLabel: product_impression_sku,
				nonInteraction: 1
			});

		}

		if (qlOpenBoxPlaLink) {

			trackPLAEvents({
				eventAction: 'Load-Open Box Available',
				eventLabel: product_impression_sku,
				nonInteraction: 1
			});
			qlOpenBoxPlaLink.addEventListener(
				'click',
				() => {

					const { product_impression_sku } = window.lp._ProductListingAd;
					trackPLAEvents({
						eventAction: 'Click-Open Box Available',
						eventLabel: product_impression_sku
					});

				},
				{ once: true }
			);

		}

		turntoTeaser.forEach((element) => {

			element.addEventListener(
				'click',
				() => {

					utagLinkPLA('TurnTo')({
						eventAction: 'PLA-teaserClick',
						eventLabel: window.shortSku
					});

				},
				{ once: true }
			);

		});

		listType = qlContainer.getAttribute('data-list-type');

		qlProductLinks.map((element) => setIndividualProductClick(element, listType));

		qlProductLinks.map((link) => captureSkuAndListType(link, listType));

	}

	// setup product click for Full SFP page certona results
	if (container) {

		const sortResultContainers = container.querySelectorAll('.sortResultContainer > a');

		listType = container.getAttribute('data-list-type');
		setProductClick(listType, sortResultContainers);
		captureSkuAndPosition(sortResultContainers);

		const moreLikeThisLinks = container.querySelectorAll('.sortResultContainer .sortMoreLikeThisBtn');
		moreLikeThisLinks.forEach((link) => {

			link.addEventListener('click', () => {

				const sortResult = link.closest('.sortResultContainer');
				const sku = isSfpSort ? sortResult.dataset.sku : sortResult.querySelector('a').dataset.certonasku;
				trackPLAEvents({
					eventAction: 'Click-More-Like-This',
					eventLabel: sku
				});

			});

		});

	}

});

// initialize select_item (GA4) event after recommended items load
document.addEventListener('recommendedItems:similar2:loaded', () => {

	const qlCertonaContainer = document.getElementById('qlCertonaContainer');

	if (qlCertonaContainer) {

		const sortResultContainers = qlCertonaContainer.querySelectorAll('.sortResultContainer > a');

		sortResultContainers.forEach((el) => {

			el.addEventListener('click', (e) => {

				// GA4 "select_item" event
				const captureElement = e.currentTarget.querySelector('img[data-sku]');
				if (captureElement) {

					utagLinkSelectItem({
						sku: captureElement.dataset.sku,
						name: captureElement.title || captureElement.alt,
						price: captureElement.dataset.price,
						skuInputType: captureElement.dataset.skuInputType,
						primaryCategory: captureElement.dataset.primaryCategory
					});

				}

			});

		});

		trackDyRecommendedItemClickEvent({ selector: sortResultContainers });

	}

});

document.addEventListener('recommendedItems:loaded', () => {

	trackSortMoreYouMayLike();

});
